import { NavLink } from 'react-router-dom';

import ZuiLink from '@zenbusiness/zui/Link';
import MenuItem from '@zenbusiness/zui/MenuItem';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'UserMenu',
  slot: 'MenuItem',
  tag: MenuItem,
  propsNeeded: ['divider'],
  styles: ({ divider, theme }) => ({
    padding: '0',

    '&& > *': {
      paddingBlock: '0.75rem',

      [theme.breakpoints.up('lg')]: {
        paddingBlock: '1.125rem'
      }
    },

    ...(divider === 'top' && {
      borderTop: `1px solid ${theme.palette.border.main}`
    }),

    ...(divider === 'bottom' && {
      borderBottom: `1px solid ${theme.palette.border.main}`
    }),

    '&.Mui-focusVisible, &:hover, & .active': {
      background: 'rgba(207, 249, 250, 0.4)'
    }
  })
});

export const Link = superstyled({
  name: 'UserMenu',
  slot: 'MenuItemLink',
  tag: ZuiLink,
  propsAdded: {
    component: NavLink
  },
  styles: () => ({
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    textDecoration: 'none',
    textTransform: 'capitalize'
  })
});
